import {useContext} from "react";
import {StateContext} from "../Contexts";
import {getCurrentPlan} from "../Billwerk/SubscriptionJS";
import fireIcon from "../../../img/fire.png";

/**
 * @returns {JSX.Element}
 */
export default function () {
    /** @type {CheckoutState} state */
    const state = useContext(StateContext);

    if (state.productInfo && state.mainProps.voucher === 'BW25ULTIMATE') {
        return <div className="flex flex-row gap-3 items-center bg-blue text-white text-2xl font-bold px-6 py-4 rounded-sm">
            <img src={fireIcon} className="w-[20px] h-[20px]"/>
            <span>Glückwunsch! Sie gehören zu den ersten 20 Besteller:innen!</span>
        </div>
    }

    let plan = getCurrentPlan(state);

    let component = plan?.components['black-weekend-power-booster'] ?? plan?.components['cyberweek-power-booster'] ?? null;

    if (!plan || !component) {
        return null;
    }

    let congrats = <></>
    let benefits = <></>
    let ribbonText = '';

    if (plan.external_id === 'bw25special-business') {
        benefits = <>
            <p class="text-blue font-bold">Zusätzlich in diesem Black Weekend Spezial-Angebot</p>
            <ul>
                <li><strong>Ein umfassender Rechtstexte-Check</strong> – rechtliche Prüfung durch
                    Anwält:innen der Partnerkanzlei Siebert Lexow für maximale Rechtssicherheit Ihres Textes.
                </li>
                <li><strong>+ 50.000 Sessions pro Projekt/Monat</strong> – mehr Reichweite und stabile Performance, auch bei
                    wachsendem Traffic.
                </li>
                <li><strong>+ 50 Projekte</strong> – zusätzliche Flexibilität für Websites, Shops oder Testumgebungen.</li>
            </ul>
        </>

        ribbonText = 'Im Wert von 500€';
    } else if (plan.external_id === 'bw25special-enterprise') {
        congrats = <div className="flex flex-row gap-3 items-center bg-blue text-white text-2xl font-bold px-6 py-4 rounded-sm">
            <img src={fireIcon} className="w-[20px] h-[20px]"/>
            <span>Glückwunsch! Sie gehören zu den ersten 100 Besteller:innen!</span>
        </div>

        benefits = <>
            <p className="text-blue font-bold">Zusätzlich in diesem Black Weekend Spezial-Angebot</p>
            <ul>
                <li><strong>Drei umfassende Rechtstexte-Checks</strong> – rechtliche Prüfung durch
                    die Partnerkanzlei Siebert Lexow für maximale Rechtssicherheit Ihrer wichtigsten Texte.
                </li>
                <li><strong>+ 100.000 Sessions pro Projekt/Monat</strong> – maximale Kapazität für hohe Besucherzahlen.
                </li>
                <li><strong>Exklusives Live-Q&amp;A mit RA Sören Siebert &amp; RA Lev Lexow</strong> – fünf
                    Kleingruppen-Sessions mit maximal 20 Teilnehmenden; nur für die ersten 100 Buchungen.
                </li>
            </ul>
            <p>Direkter Zugang zu Deutschlands Top-IT-Rechtsexperten und exklusivem Expertenwissen aus erster Hand.</p>
        </>

        ribbonText = 'Im Wert von 950€';
    } else if (plan.external_id === 'cm25special-basic') {
        benefits = <>
            <p className="text-blue font-bold">Zusätzlich in diesem Cyber Monday Spezial-Angebot</p>
            <ul>
                <li><strong>Business-Checklisten</strong> – erstellt von der Partnerkanzlei Siebert
                    Lexow, zugeschnitten auf Ihr Geschäftsmodell.
                </li>
            </ul>
            <p>Praxisnahe Starthilfe für einen rechtssicheren und professionellen Webauftritt. Perfekter Einstieg für ein sicheres und strukturiertes Online-Business.</p>
        </>

        ribbonText = 'Im Wert von 250€';
    } else if (plan.external_id === 'cm25special-business') {
        benefits = <>
            <p className="text-blue font-bold">Zusätzlich in diesem Cyber Monday Spezial-Angebot</p>
            <ul>
                <li><strong>Ein umfassender Rechtstexte-Check</strong> – rechtliche Prüfung durch die
                    Partnerkanzlei Siebert Lexow für höchste Rechtssicherheit Ihres Textes.
                </li>
                <li><strong>+ 75.000 Sessions pro Projekt/Monat</strong> – zusätzliche Reichweite und stabile Performance
                    bei steigendem Traffic.
                </li>
            </ul>
            <p>Rechtssicherheit und Wachstum vereint – für Online-Projekte, die professionell überzeugen sollen.</p>
        </>

        ribbonText = 'Im Wert von 350€';
    } else if (plan.external_id === 'cm25special-enterprise') {
        benefits = <>
            <p className="text-blue font-bold">Zusätzlich in diesem Cyber Monday Spezial-Angebot</p>
            <ul>
                <li><strong>Drei umfassende Rechtstexte-Checks</strong> – rechtliche Prüfung
                    durch Anwält:innen der Partnerkanzlei Siebert Lexow für maximale Rechtssicherheit Ihrer wichtigsten
                    Texte.
                </li>
                <li><strong>+ 100.000 Sessions pro Projekt/Monat</strong> – stabile Performance auch bei starkem
                    Traffic.
                </li>
                <li><strong>Onboarding „DatenschutzPro“</strong> – persönliche Einführung durch Experten von LegalTrust
                    in das Tool zur zentralen Verwaltung und Dokumentation aller Datenschutzmaßnahmen.
                </li>
            </ul>
            <p>Das Rundum-Paket für alle, die Rechtssicherheit, Datenschutz und technisches Wachstum effektiv verbinden möchten.</p>
        </>

        ribbonText = 'Im Wert von 900€';
    }

    return <div className="flex flex-col gap-10">
        {congrats}
        <div
            className={`relative flex flex-col bg-clip-border rounded-sm border-2 border-[rgba(0,148,216,0.3)] /*bg-[image:var(--image-url)]*/ /*bg-cover bg-no-repeat*/ text-white shadow-card overflow-hidden powerbooster-bg`}>
            {ribbonText &&
                <div
                    className="bg-[#0094D8] text-white uppercase text-lg text-center font-extrabold rotate-[24.24deg] absolute w-[540px] h-[35px] leading-[35px] top-[24px] right-[-188px] hidden sm:block">
                    {ribbonText}
                </div>
            }
            <div className="pt-[1.5rem] pr-[1.5rem] pb-[1.5rem] pl-[88px]">
                <div className="flex flex-col gap-10">
                    <div className="flex flex-row gap-5 items-start">
                        <div className="flex flex-col grow gap-4">
                            <div className="flex flex-row justify-between items-center md:items-start gap-5 md:gap-2">
                                <div className="flex flex-row items-center">
                                    <h4 className="h3 text-white text-left">{component.name}</h4>
                                </div>
                            </div>
                            <div className="powerbooster--benefits flex flex-col gap-4">
                                {benefits}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
